export default "__VITE_ASSET__gW5etmSX__"